// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__t4fLY","header":"Messages_header__1fpa8"};